import { useWorldReadyContext } from '../../context/WorldReadyContext'
import { MessageFormat } from '@paypalcorp/worldready'

export function useMessage() {
  const worldReady = useWorldReadyContext()
  return function message(id, formatParams) {
    return new MessageFormat(worldReady, { id }).format(formatParams)
  }
}
